import React, { lazy, Suspense, useEffect, useState } from "react";
import moment from "moment/moment.js";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Input, SubTitle } from "../../Components/CustomComponents/index.js";
import SimpleTable from "../../Components/Table/SimpleTable.js";
import Pagination from "../../Components/Pagination/Pagination.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

//
import { CgBlock, CgUnblock } from "react-icons/cg";
import { MdDeleteForever, MdDone } from "react-icons/md";
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { useGetAllRestaurantQuery } from "../../Data/services/restaurantApi.js";
import {
  useBlockUserMutation,
  useDeleteUserMutation,
  useUnBlockUserMutation,
} from "../../Data/services/userApi.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";

const CustomerBlockModal = lazy(() =>
  import("../../Components/Modals/CustomerBlockModal.js")
);

const RestaurantManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [blockModal, setBlockModal] = useState(false);
  const [forBlock, setForBlock] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [orderBy, setOrderBy] = useState("firstname");
  const [order, setOrder] = useState("ASC");

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 400);
    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  const { data, isSuccess, isLoading, isFetching, isError, refetch } =
    useGetAllRestaurantQuery(
      {
        search: debouncedSearchQuery.length >= 3 ? debouncedSearchQuery : "",
        start_date: startDate != null ? startDate : "",
        end_date: endDate != null ? endDate : "",
        limit: pageSize,
        page: currentPage,
        orderBy: orderBy,
        order: order,
      },
      { refetchOnMountOrArgChange: true }
    );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setDataFetched(true);
      setRowData(data.data || []);
      if (!data.data || data.data.length === 0) {
        setIndicationMessage("No Restaurants Found");
      }
    }
  }, [data]);

  useEffect(() => {
    if (isError) {
      setRowData([]);
      setTotalRecords(0);
      setTotalPages(0);
      setDataFetched(true);
      setIndicationMessage("No Restaurants Found");
    }
  }, [isError]);

  const handleBlockModalOpen = () => {
    setBlockModal(true);
  };

  const handleBlockModalClose = () => {
    setBlockModal(false);
    setEditedData("");
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const [blockUser, { isLoading: isBlocking }] = useBlockUserMutation();
  const [unBlockUser, { isLoading: isUnBlocking }] = useUnBlockUserMutation();

  const handleBlockOrUnblock = async (userSlug, isBlock) => {
    // console.log(userSlug);
    // console.log(isBlock);
    setLoading(true);
    // setTimeout(() => {
    //   setLoading(false);
    //   handleBlockModalClose();
    // }, 2000);
    try {
      let response;
      if (isBlock) {
        response = await blockUser(userSlug);
      } else {
        response = await unBlockUser(userSlug);
      }

      // console.log(response.data);

      if (response.data.code === 200) {
        await refetch();
        setLoading(false);
        handleBlockModalClose();
        SuccessToast(response.data?.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteUser(slug);

      // console.log(data);

      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast("Restaurant deleted successfully");
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      headerStyle: {
        width: "150px",
      },
      onSort: (field, order) => {
        setOrderBy("firstname");
        setOrder(order === "desc" ? "DESC" : "ASC");
      },
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row justify-content-start align-items-center gap-2">
            <img
              alt="restaurant"
              src={row.image_url || "/images/default-restaurant.svg"}
              loading="lazy"
              width={48}
              height={48}
              className="rounded-circle object-fit-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/default-restaurant.svg";
              }}
            />
            <div className="lc-1"> {row.name || 'N/A'} </div>
          </div>
        );
      },
    },
    {
      dataField: "email",
      text: "Email",
      // sort: true,
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex align-items-center gap-2">
            <i className="bi bi-envelope text-muted small"></i>
            <span className="text-wrap-custom small" style={{fontSize: '0.85rem'}}>
              {row.email || 'N/A'}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "mobile_no",
      text: "Phone",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center gap-2">
            <i className="bi bi-telephone text-muted small"></i>
            <span className="text-wrap-custom small" style={{fontSize: '0.85rem'}}>
              {row.mobile_no || 'N/A'}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "createdAt",
      text: "Created At",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "150px",
      },
      onSort: (field, order) => {
        setOrderBy("createdAt");
        setOrder(order === "desc" ? "DESC" : "ASC");
      },
      formatter: (cellContent, row) => {
        return (
          <span className="text-wrap-custom small" style={{fontSize: '0.85rem'}}>
            {row.createdAt ? moment(row.createdAt).format("MMM DD, YYYY") : 'N/A'}
          </span>
        );
      },
    },
    {
      dataField: "is_blocked",
      text: "Status",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      onSort: (field, order) => {
        // console.log(field);
        // console.log(order);
        setOrderBy("is_blocked");
        setOrder(order === "desc" ? "DESC" : "ASC");
      },
      formatter: (cellContent, row) => {
        if (row.is_blocked) {
          return (
            <div className={`${styles.block} d-flex align-items-center justify-content-center gap-1`}>
              <i className="bi bi-shield-x small"></i>
              <span>Blocked</span>
            </div>
          );
        }
        return (
          <div className={`${styles.active} d-flex align-items-center justify-content-center gap-1`}>
            <i className="bi bi-shield-check small"></i>
            <span>Active</span>
          </div>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        if (row.slug) {
          return (
            <div className={`d-flex justify-content-center align-items-center gap-2 ${styles.mobileActions}`}>
              {row.is_blocked ? (
                <div
                  className={`d-flex justify-content-center align-items-center bg-success-hover rounded-3 p-2 mx-1 actionButton`}
                  role="button"
                  onClick={() => {
                    setForBlock(false);
                    setEditedData(row);
                    handleBlockModalOpen();
                  }}
                  title="Unblock Restaurant"
                >
                  <span className={`d-flex align-items-center pe-1`}>
                    <CgUnblock />
                  </span>
                  <span className="d-none d-xl-block">Unblock</span>
                </div>
              ) : (
                <div
                  className={`d-flex justify-content-center align-items-center bg-warning-hover rounded-3 p-2 mx-1 actionButton`}
                  role="button"
                  onClick={() => {
                    setForBlock(true);
                    setEditedData(row);
                    handleBlockModalOpen();
                  }}
                  title="Block Restaurant"
                >
                  <span className={`d-flex align-items-center pe-1`}>
                    <CgBlock />
                  </span>
                  <span className="d-none d-xl-block">Block</span>
                </div>
              )}
              <div
                className={`d-flex justify-content-center align-items-center bg-danger text-white rounded-3 p-2 mx-1 actionButton`}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleDeleteModalOpen();
                }}
                title="Delete Restaurant"
              >
                <span className={`d-flex align-items-center pe-1`}>
                  <MdDeleteForever />
                </span>
                <span className="d-none d-xl-block">Delete</span>
              </div>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {blockModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <CustomerBlockModal
            forBlock={forBlock}
            handleBlockModalClose={handleBlockModalClose}
            data={editedData}
            onAction={handleBlockOrUnblock}
            loading={loading}
          />
        </Suspense>
      ) : (
        ""
      )}

      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {
        //   editModal ? (
        //   <EditUserModal
        //     handleEditModalClose={handleEditModalClose}
        //     data={editedData}
        //   />
        // ) : (
        //   ""
        // )
      }

      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"Restaurant Management"} classes="text-black" />
            </div>
          </Col>

          <Col md={6}>
            <div className={`d-flex flex-column flex-md-row gap-2 ${styles.searchFilterContainer}`}>
              <div className={styles.searchContainer}>
                <label className="form-label small text-muted mb-1">Search</label>
                <Input
                  placeholder="Search by name or email"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  classes={styles.searchInput}
                />
              </div>
              <div className={styles.dateInputContainer}>
                <label className="form-label small text-muted mb-1">From Date</label>
                <Input
                  type="date"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  classes={styles.dateInput}
                />
              </div>
              <div className={styles.dateInputContainer}>
                <label className="form-label small text-muted mb-1">To Date</label>
                <Input
                  type="date"
                  placeholder="End Date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  classes={styles.dateInput}
                />
              </div>
            </div>
          </Col>
        </Row>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add User"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

       <div className={styles.mainTable}>
         {!dataFetched || isLoading ? (
           <CustomLoader />
         ) : (
           <div className={styles.tableContent}>
             <SimpleTable
               data={rowData}
               columns={columns}
               indication={indication}
               totalRecords={totalRecords}
               totalPages={totalPages}
               pageSize={pageSize}
               currentPage={currentPage}
               setCurrentPage={setCurrentPage}
               setPageSize={setPageSize}
               refetch={refetch}
               showPagination={false}
             />
           </div>
         )}
       </div>

       {/* Pagination outside the table div */}
       {dataFetched && isSuccess && totalPages > 1 && (
         <div className={styles.paginationWrapper}>
           <Pagination
             currentPage={currentPage}
             totalPages={totalPages}
             totalRecords={totalRecords}
             pageSize={pageSize}
             onPageChange={(page) => {
               setCurrentPage(page);
             }}
             onPageSizeChange={(newSize) => {
               setPageSize(newSize);
               setCurrentPage(1);
             }}
             showPageSizeSelector={true}
             showRecordsInfo={true}
           />
         </div>
       )}
    </div>
  );
};

export default RestaurantManagementScreen;
